import React from 'react'
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';

const TermsAndCondition = () => {
    return (
        <PageWrapper isProtected={false} title={'Terms & Condition'} className={'bg-light'}>
            <Page className='p-0'>
                <div className='row h-100 align-items-center'>
                    <div className='shadow-3d-container'>
                        <h1>Terms & Conditions</h1>

                        <p>
                            By accessing or using our application, you agree to be bound by these Terms & Conditions.
                        </p>

                        <h3>1. Use of Service</h3>
                        <p>
                            You agree to use our platform only for lawful purposes and in a way that does not harm others or the application.
                        </p>

                        <h3>2. User Accounts</h3>
                        <p>
                            You are responsible for maintaining the confidentiality of your account and password.
                        </p>

                        <h3>3. Intellectual Property</h3>
                        <p>
                            All content, design, and code are the property of our company and cannot be reused without permission.
                        </p>

                        <h3>4. Limitation of Liability</h3>
                        <p>
                            We are not responsible for any damages arising from the use or inability to use our service.
                        </p>

                        <h3>5. Termination</h3>
                        <p>
                            We reserve the right to suspend or terminate your access if you violate these terms.
                        </p>

                        <h3>6. Changes to Terms</h3>
                        <p>
                            We may update these Terms & Conditions at any time. Continued use of the service means you accept the changes.
                        </p>

                        <h3>7. Contact Us</h3>
                        <p>
                            For any questions regarding these terms, contact us at: [pro@neelssanjayraj.com]
                        </p>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    )
}

export default TermsAndCondition
